module.exports = __webpack_public_path__ + "media/images/type-3-7047100d30a5adf7ad3236dabd09f60d.png";